import * as React from 'react';
import { CenterView } from '../../containers';
import { AltoSpinningLoader } from '../../loaders';

export type LoadingEmptyStateProps = {
  readonly small?: boolean;
};

export const LoadingEmptyState = ({ small = true }: LoadingEmptyStateProps) => {
  return (
    <CenterView>
      <AltoSpinningLoader
        accessibilityLabel="loading"
        small={small}
        testID="loading"
      />
    </CenterView>
  );
};
